import { CotizacionVenta, CotizacionVentaDetalle } from '../services/cotizacionVentaService';
import { PedidoVenta, PedidoVentaDetalle } from '../services/pedidoVentaService';
import { cantidadUmIngresoFromSnapshot } from './umDocumentoDisplay';

/**
 * Transforma una CotizacionVenta a PedidoVenta para pre-cargar el formulario de pedido.
 * La única diferencia sustancial es nroTipoFormulario: "12" (pedido) en lugar de "10" (cotización).
 */
export const transformarCotizacionAPedido = (cotizacion: CotizacionVenta): PedidoVenta => {
  const detalles: PedidoVentaDetalle[] = (cotizacion.detalles || []).map((d: CotizacionVentaDetalle) => {
    const ingreso = cantidadUmIngresoFromSnapshot(d, 'ped');
    return {
      nroIdformulario: d.nroIdformulario,
      nroItem: d.nroItem,
      codigoArticulo: d.codigoArticulo,
      descripcionArticulo: d.descripcionArticulo,
      cantidad: ingreso.cantidad,
      precioUnitario: ingreso.precioUnitario ?? d.precioUnitario ?? d.precioLista,
      descuento: d.descuento ?? d.porcDesc,
      porcDesc: d.porcDesc,
      subtotal: d.subtotal,
      notas: d.notas,
      um: ingreso.um || d.um,
      cantidadUmped: d.cantidadUmped,
      umped: d.umped,
      equivUmped: d.equivUmped,
      precioUnitarioUmped: d.precioUnitarioUmped,
      codigoMoneda: d.codigoMoneda,
      cotizacion: d.cotizacion,
    };
  });

  return {
    ...cotizacion,
    nroTipoFormulario: '12',
    detalles,
  } as PedidoVenta;
};
